// src/components/CalidadesSection.js
import React from "react";
import "./CalidadesSection.css";
import calidadesImage from "../assets/img/Unknown-1.jpg"; // Add your image

const CalidadesSection = () => {
  return (
    <section className="calidades-section">
      {/* Title Section */}
      <div className="calidades-title-container">
        <h2 className="calidades-title">Memoria de Calidades</h2>
      </div>

      <div className="calidades-divider"></div>

      {/* Two Column Content */}
      <div className="calidades-columns">
        {/* Left Column */}
        <div className="calidades-col">
          <h3 className="column-subtitle">CIMENTACIÓN Y ESTRUCTURA</h3>
          <p className="column-text">
            Cimentación profunda de hormigón armado proyectada conforme a las
            conclusiones del Estudio Geotécnico.
            <br />
            Estructura de pilares y forjados de hormigón armado, según Normativa
            vigente y Proyecto de Ejecución.
          </p>

          <h3 className="column-subtitle">FACHADA Y CUBIERTA</h3>
          <p className="column-text">
            La fachada se resuelve con una hoja principal del cerramiento de
            ladrillo cerámico con una primera capa de aislante adosado a la hoja
            principal y una segunda capa inserta en la subestructura del
            trasdosado interior, terminado con placas de yeso laminado, para un
            alto confort térmico y acústico. Además, se incluyen aislamientos
            adicionales que permiten la reducción de puentes térmicos en
            encuentros entre los forjados y las fachadas, mejorando la
            eficiencia energética del edificio. <br />
            El edificio dispone de una cubierta principal inclinada con acabado
            de teja cerámica.
            <br />
            Los áticos dispondrán de terrazas en cubiertas planas de solución
            invertida con lo que el aislamiento térmico se coloca sobre el
            sistema de impermeabilización, protegiéndolo. Esta solución mejora
            la eficiencia energética y reduce la aparición de patologías
            relacionadas con las filtraciones y humedad.
          </p>

          <h3 className="column-subtitle">PARTICIONES INTERIORES</h3>
          <p className="column-text">
            La separación entre zonas comunes y viviendas se resuelve mediante
            combinación de una hoja tradicional de ladrillo cerámico con un
            trasdosado de placas de yeso laminado que incluye aislamiento, para
            un alto nivel de aislamiento térmico-acústico.
            <br />
            En interior de las viviendas las particiones se resuelven mediante
            sistema de tabiquería en seco con aislamiento térmico-acústico.
          </p>
        </div>

        {/* Right Column */}
        <div className="calidades-col">
          <h3 className="column-subtitle">CARPINTERÍA EXTERIOR</h3>
          <p className="column-text">
            <b>Carpintería</b>
            <br></br>
            La carpintería exterior se realizará con perfilería en aluminio
            lacado y sistemas de alta calidad que garantizan el aislamiento
            acústico del entorno y con rotura de puente térmico que evita la
            condensación y el frío en los marcos de las ventanas, cumpliendo así
            la normativa actual en esta materia.
          </p>
          <p className="column-text">
            El sistema de apertura se definirá en proyecto en función de las
            exigencias de la normativa y de la ubicación de las mismas. Las
            defensas de terrazas y huecos irán confeccionadas con el mismo
            material.
            <br />
            El acristalamiento de las ventanas será de vidrio doble con cámara
            de aire intermedia, garantizando así el debido aislamiento de
            intercambio de energía y ruido.
            <br />
            <br />
            <b>Persianas</b>
            <br />
            En los dormitorios se incorporan persianas para regular la
            iluminación y controlar la entrada del sol. En fachada principal se
            instalará un sistema de control solar que permitirá múltiples
            configuraciones para regular tanto la iluminación como las vistas.
          </p>

          <h3 className="column-subtitle">CARPINTERÍA INTERIOR</h3>
          <p className="column-text">
            Las puertas de entrada a viviendas serán blindadas para garantizar
            la máxima seguridad y estarán paneladas en su cara interior acorde
            con el acabado de puertas de paso interiores. Las puertas interiores
            serán de forma recta y lisas en color blanco.
            <br />
            Todos los dormitorios contarán con armarios empotrados sin obra, con
            los mismos acabados que las puertas de paso y dispondrán en su
            interior balda y barra de colgar.
          </p>
        </div>
      </div>
      <div className="calidades-divider"></div>

      <div className="calidades-columns">
        {/* Left Column */}
        <div className="calidades-col">
          <h3 className="column-subtitle">
            REVESTIMIENTOS INTERIORES Y PINTURAS
          </h3>
          <p className="column-text">
            <b>Solados y alicatados</b>
            <br />
            Se ofrecen materiales cerámicos cuidadosamente seleccionados tanto
            en pavimentos como en revestimientos de las zonas húmedas.
            <br />
            <b>Pinturas</b>
            <br />
            Para el resto de paramentos de la vivienda se empleará pintura
            plástica lisa. Todos los techos se terminarán con pintura plástica,
            en blanco liso mate.
          </p>

          <h3 className="column-subtitle">FALSOS TECHOS</h3>
          <p className="column-text">
            Los falsos techos tienen como misión ocultar el paso de
            instalaciones y se emplearán en los espacios que los requieran. Se
            emplearán materiales basados en placas cartón-yeso, con registros
            según sea necesario.
          </p>

          <h3 className="column-subtitle">INSTALACIONES</h3>
          <p className="column-text">
            <b>Electricidad</b>
            <br></br>
            La instalación eléctrica de la vivienda cumplirá con la normativa
            vigente y dado el tamaño y equipamiento de esta, estará preparada
            para un grado de electrificación elevada. <br />
            En terrazas exteriores se dotarán tomas de corriente y luminarias
            acordes con el grado de protección a ambientes exteriores, según lo
            estipulado en proyecto.
          </p>
          <p className="column-text">
            <b>Fontanería</b>
            <br />
            La instalación de fontanería se ejecutará atendiendo a las
            prescripciones del proyecto y de la normativa vigente. Se
            garantizará el perfecto funcionamiento y se cuidará la ubicación de
            llaves de corte independientes en cada cuarto húmedo y la llave de
            corte general de vivienda.
          </p>
        </div>

        {/* Right Column */}
        <div className="calidades-col">
          <h3 className="column-subtitle">SANEAMIENTO</h3>
          <p className="column-text">
            Se instalará conforme a la normativa vigente. Se emplearán sistemas
            con aislamiento acústico y se diseñará en lo posible para asegurar
            un sistema de ventilación primaria.
          </p>

          <h3 className="column-subtitle">AGUA CALIENTE SANITARIA</h3>
          <p className="column-text">
            Se implementará un sistema de energía aerotérmica, un sistema ideal
            que extrae la energía del aire y la transfiere al agua caliente
            mediante una bomba de calor, generando una producción de agua
            caliente sanitaria con un bajo consumo energético.
          </p>
          <h3 className="column-subtitle">CLIMATIZACIÓN</h3>
          <p className="column-text">
            Se instala un sistema de climatización con bomba de calor por
            conductos individual en cada vivienda.
          </p>
          <h3 className="column-subtitle">
            SISTEMA DE VENTILACIÓN Y EXTRACCIÓN
          </h3>
          <p className="column-text">
            Se incorpora un sistema de ventilación y extracción mecánica
            comunitaria de simple flujo que garantiza la calidad del aire
            interior, proporcionando una ventilación eficiente y un caudal
            óptimo de entrada de aire del exterior.
            <br /> La entrada de aire se producirá a través de un sistema de
            microventilación en ventanas según indicaciones en proyecto y se
            extraerá el aire desde cuartos húmedos, garantizando unos parámetros
            óptimos de la calidad del aire.
          </p>
        </div>
      </div>
      <div className="calidades-divider"></div>

      <div className="calidades-columns">
        {/* Left Column */}
        <div className="calidades-col">
          <h3 className="column-subtitle">TELECOMUNICACIONES, DATOS Y TV</h3>
          <p className="column-text">
            Las viviendas contarán con tomas de datos y TV según normativa
            vigente.
          </p>

          <h3 className="column-subtitle">VIDEOPORTERO</h3>
          <p className="column-text">
            Las viviendas dispondrán de un sistema de videoportero.
          </p>

          <h3 className="column-subtitle">
            MOBILIARIO Y EQUIPAMIENTO DE COCINA
          </h3>
          <p className="column-text">
            La cocina, diseñada con materiales de calidad, potencia la
            funcionalidad y confort con una distribución de muebles altos y
            bajos que integran encimeras porcelánicas de alta compacidad y
            frentes de cocina acordes a la selección de materiales.
          </p>
          <h3 className="column-subtitle">SANITARIOS Y GRIFERÍA</h3>
          <p className="column-text">
            Los sanitarios serán de porcelana vitrificada y la grifería cromada
            tipo monomando. Se instalarán platos de ducha de gran formato.
            Además se preverá un punto de luz tipo aplique para los espejos de
            los baños.
          </p>
          <h3 className="column-subtitle">ELEMENTOS COMUNES</h3>
          <p className="column-text">
            Los elementos comunes guardarán un estilo atemporal, sencillo y
            cuidado, especialmente en el zaguán, donde se realizará una
            combinación de materiales cerámicos con las cerrajerías y
            revestimientos de paramenteos.
          </p>
        </div>

        {/* Right Column */}
        <div className="calidades-col-image">
          <img
            src={calidadesImage}
            alt="Memoria de Calidades"
            className="calidades-image"
          />
        </div>
      </div>

      {/* Full Width Footnote */}
      <div className="calidades-footnote">
        <p>
          NOTA: Las calidades de los materiales e instalaciones incluidos en el
          presente catálogo, tienen carácter meramente informativo, no
          vinculante, pudiendo ser susceptibles de modificaciones por
          necesidades arquitectónicas, estéticas, comerciales, técnicas o
          funcionales, así como por instrucciones de la Dirección Facultativa de
          la obra. Asimismo, algunas características y materiales podrán ser
          variados en función de las disponibilidades del mercado, y en todo
          caso conservarán los parámetros y nivel de calidad igual o superior a
          la indicada.
        </p>
      </div>
    </section>
  );
};

export default CalidadesSection;
